import React, { useState } from 'react';
import Colors from '../../../utils/colors';
import { Check } from 'lucide-react';

export enum CheckBoxSeverity {
  SUCCESS,
  DANGER,
  WARNING,
  LIGHT_APPROVE,
}
export interface CustomCheckboxDatamodel {
  severity: CheckBoxSeverity;
  checked: boolean;
  onChange: (checked: boolean) => any;
}
export const ColorfulCheckbox: React.FC<CustomCheckboxDatamodel> = ({
  severity,
  checked,
  onChange,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const getColor = () => {
    switch (severity) {
      case CheckBoxSeverity.SUCCESS:
        return Colors.approveText;
      case CheckBoxSeverity.WARNING:
        return Colors.warningText;
      case CheckBoxSeverity.DANGER:
        return Colors.dangerText;
      case CheckBoxSeverity.LIGHT_APPROVE:
        return Colors.lightApprove;
    }
  };

  const checkboxStyle = {
    width: '22px',
    height: '22px',
    borderRadius: '6px',
    cursor: 'pointer',
    border: `2px solid ${isHovered || checked ? getColor() : '#d1d5db'}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: checked ? getColor() : 'white',
    transition: 'background-color 0.01s ease',
  };

  const iconStyle = {
    color: 'white',
  };

  return (
    <div
      style={checkboxStyle}
      onClick={() => onChange(!checked)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {checked && <Check style={iconStyle} size={16} />}
    </div>
  );
};
